<template>
  <div>
    <!-- Main Headline -->
    <sc-text tag="h3" v-if="fields && fields.heading" :field="fields.heading" />

    <!-- Default Message -->
    <sc-text
      tag="p"
      class="c-filter-info-default"
      v-if="fields && fields.defaultMessage"
      :field="fields.defaultMessage"
    />

    <!-- CIS Benchmarks -->
    <div class="c-filter-info cis-benchmarks-owner" :class="{ active: isBenchmark }">
      <sc-image
        @click="isBenchmark = !isBenchmark"
        v-if="fields && fields.benchmarkImage"
        :media="fields.benchmarkImage"
      />
      <div class="c-filter-info-container" :class="{ active: isBenchmark, editing: isEditing }">
        <sc-text tag="div" v-if="fields && fields.benchmarkDesc" :field="fields.benchmarkDesc" />
        <sc-link
          v-if="fields && fields.benchmarkLink"
          :field="fields.benchmarkLink"
          class="c-cta--tertiary"
        />
      </div>
    </div>

    <!-- CIS Contrtols -->
    <div class="c-filter-info cis-controls-owner" :class="{ active: isControls }">
      <sc-image
        @click="isControls = !isControls"
        v-if="fields && fields.controlsImage"
        :media="fields.controlsImage"
      />
      <div class="c-filter-info-container" :class="{ active: isControls, editing: isEditing }">
        <sc-text tag="div" v-if="fields && fields.controlsDesc" :field="fields.controlsDesc" />
        <sc-link
          v-if="fields && fields.controlsLink"
          :field="fields.controlsLink"
          class="c-cta--tertiary"
        />
      </div>
    </div>

    <!-- CIS CyberMarket -->
    <div class="c-filter-info cis-cybermarket-owner" :class="{ active: isCyber }">
      <sc-image
        @click="isCyber = !isCyber"
        v-if="fields && fields.cyberImage"
        :media="fields.cyberImage"
      />
      <div class="c-filter-info-container" :class="{ active: isCyber, editing: isEditing }">
        <sc-text tag="div" v-if="fields && fields.cyberDesc" :field="fields.cyberDesc" />
        <sc-link
          v-if="fields && fields.cyberLink"
          :field="fields.cyberLink"
          class="c-cta--tertiary"
        />
      </div>
    </div>

    <!-- CIS Hardened Images -->
    <div class="c-filter-info cis-hardened-images-owner" :class="{ active: isHardened }">
      <sc-image
        @click="isHardened = !isHardened"
        v-if="fields && fields.hardenedImage"
        :media="fields.hardenedImage"
      />
      <div class="c-filter-info-container" :class="{ active: isHardened, editing: isEditing }">
        <sc-text tag="div" v-if="fields && fields.hardenedDesc" :field="fields.hardenedDesc" />
        <sc-link
          v-if="fields && fields.hardenedLink"
          :field="fields.hardenedLink"
          class="c-cta--tertiary"
        />
      </div>
    </div>

    <!-- CIS SecureSuite -->
    <div class="c-filter-info cis-securesuite-owner" :class="{ active: isSecure }">
      <sc-image
        @click="isSecure = !isSecure"
        v-if="fields && fields.secureImage"
        :media="fields.secureImage"
      />
      <div class="c-filter-info-container" :class="{ active: isSecure, editing: isEditing }">
        <sc-text tag="div" v-if="fields && fields.secureDesc" :field="fields.secureDesc" />
        <sc-link
          v-if="fields && fields.secureLink"
          :field="fields.secureLink"
          class="c-cta--tertiary"
        />
      </div>
    </div>

    <!-- CIS Services -->
    <div class="c-filter-info cis-services-owner" :class="{ active: isServices }">
      <sc-image
        @click="isServices = !isServices"
        v-if="fields && fields.servicesImage"
        :media="fields.servicesImage"
      />
      <div class="c-filter-info-container" :class="{ active: isServices, editing: isEditing }">
        <sc-text tag="div" v-if="fields && fields.servicesDesc" :field="fields.servicesDesc" />
        <sc-link
          v-if="fields && fields.servicesLink"
          :field="fields.servicesLink"
          class="c-cta--tertiary"
        />
      </div>
    </div>

    <!-- EI-ISAC -->
    <div class="c-filter-info eiisac-owner" :class="{ active: isEiisac }">
      <sc-image
        @click="isEiisac = !isEiisac"
        v-if="fields && fields.eiisacImage"
        :media="fields.eiisacImage"
      />
      <div class="c-filter-info-container" :class="{ active: isEiisac, editing: isEditing }">
        <sc-text tag="div" v-if="fields && fields.eiisacDesc" :field="fields.eiisacDesc" />
        <sc-link
          v-if="fields && fields.eiisacLink"
          :field="fields.eiisacLink"
          class="c-cta--tertiary"
        />
      </div>
    </div>

    <!-- MS-ISAC -->
    <div class="c-filter-info msisac-owner" :class="{ active: isMsisac }">
      <sc-image
        @click="isMsisac = !isMsisac"
        v-if="fields && fields.msisacImage"
        :media="fields.msisacImage"
      />
      <div class="c-filter-info-container" :class="{ active: isMsisac, editing: isEditing }">
        <sc-text tag="div" v-if="fields && fields.msisacDesc" :field="fields.msisacDesc" />
        <sc-link
          v-if="fields && fields.msisacLink"
          :field="fields.msisacLink"
          class="c-cta--tertiary"
        />
      </div>
    </div>

    <!-- Main See All Link -->
    <sc-link v-if="fields && fields.link" :field="fields.link" class="c-cta--primary" />
  </div>
</template>

<script>
import { Text, Link, Image } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Page-Right-Rail',
  components: {
    ScText: Text,
    ScLink: Link,
    ScImage: Image
  },
  props: {
    fields: {
      type: Object
    }
  },
  data() {
    return {
      isBenchmark: false,
      isControls: false,
      isCyber: false,
      isHardened: false,
      isSecure: false,
      isServices: false,
      isEiisac: false,
      isMsisac: false
    };
  },
  computed: {
    isEditing() {
      return this.$jss.sitecoreContext().pageEditing;
    }
  }
};
</script>
<style lang="scss" scoped>
.c-list-right-rail {
  h3 {
    @include font-styles('Arial', 2rem, 200, normal, 2.4rem, 0, $dark-blue);
    margin-bottom: 3rem;

    @include desktop-up {
      font-size: 2.7rem;
      line-height: 3.5rem;
    }
  }

  p {
    @include font-styles('Arial', 1.4rem, 400, italic, 2rem, 0, $gray);
    margin-bottom: 2rem;
  }

  .c-cta--tertiary {
    margin-bottom: 1rem;
  }

  .c-cta--primary {
    margin-top: 2rem;
  }

  .c-filter-info {
    display: none;
    position: relative;
    padding-bottom: 2rem;
    margin-bottom: 2rem;
    border-bottom: solid 0.1rem $blue;

    &:before {
      content: '';
      display: inline-block;
      position: absolute;
      top: 1.5rem;
      right: 0;
      height: 1rem;
      transform: rotate(135deg);
      width: 1rem;
      z-index: -1;
      border-top: solid 0.15rem $lite-blue;
      border-right: solid 0.15rem $lite-blue;
      transition: all 0.5s ease;

      @include desktop-up {
        z-index: -1;
      }
    }

    &.active {
      &:before {
        transform: rotate(-45deg);
      }
    }

    img {
      width: 100%;
      height: auto;
      cursor: pointer;
    }

    .c-filter-info-container {
      display: none;

      &.active {
        display: block;
      }

      &.editing {
        display: block !important;
      }

      div {
        margin: 1.5rem 0 2rem 0;

        @include desktop-up {
          margin: 2rem 0;
          line-height: 2.6rem;
        }
      }
    }
  }
}
</style>
